import React from 'react';

import LinkButton from '../common/LinkButton';
import ClosableWarning from '../common/ClosableWarning';
import { CREODIAS_LINK, AWS_EU_LINK } from '../../constants/links';

const CreodiasWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: Sentinel-3 / Sentinel-5 layers</b>
        <p>
          Sentinel-3 OLCI, Sentinel-3 SLSTR and Sentinel-5 layers are processed on different
          infrastructure, which requires:
          <br />
          -The use of <LinkButton>{CREODIAS_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{AWS_EU_LINK}</LinkButton> for these layers.
          <br />
          -Other Sentinel layers as well as Landsat/MODIS/DEM layers should not be mixed with
          Sentinel-3 and Sentinel-5P layers in the same configuration instance.
        </p>
        <p>
          In the next few weeks we will migrate these two end-points, but until then please take the
          above into consideration.
        </p>
      </div>
    </ClosableWarning>
  );
};

export default React.memo(CreodiasWarning);
